import { render, staticRenderFns } from "./Tutoring.vue?vue&type=template&id=42552aa5&"
import script from "./Tutoring.vue?vue&type=script&lang=js&"
export * from "./Tutoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports